import type { BomPlacement, Placement } from '../../gql';

import { randNumber } from '@ngneat/falso';

import { mockBomMaterial } from './mockBomMaterial';
import { mockPlacement } from './mockPlacement';

const mockPlacements: Array<Placement> = [
    mockPlacement({
        placementPublicId: '1',
        placementName: 'Full',
    }),
    mockPlacement({
        placementPublicId: '2',
        placementName: 'Front',
    }),
    mockPlacement({
        placementPublicId: '3',
        placementName: 'Back',
    }),
    mockPlacement({
        placementPublicId: '4',
        placementName: 'Left',
    }),
    mockPlacement({
        placementPublicId: '5',
        placementName: 'Right',
    }),
    mockPlacement({
        placementPublicId: '6',
        placementName: 'Sleeve',
    }),
    mockPlacement({
        placementPublicId: '7',
        placementName: 'Hood',
    }),
    mockPlacement({
        placementPublicId: '8',
        placementName: 'Pocket',
    }),
];

const randomMockPlacement = (): Placement =>
    mockPlacements[randNumber({ max: mockPlacements.length - 1 })];

const mockBomPlacement = (override?: Partial<BomPlacement>): BomPlacement => ({
    placement: mockPlacements[randNumber({ max: mockPlacements.length - 1 })],
    bomMaterial: mockBomMaterial(),
    ...override,
    ['__typename']: 'BomPlacement',
});

export { mockBomPlacement, randomMockPlacement };
